import { Controller } from '@hotwired/stimulus';
import { disablePageScroll, enablePageScroll } from '@fluejs/noscroll';

const body = document.querySelector('body');

export const create = () => {
	return class extends Controller {
		clickOutside() {
			if (body.classList.contains('menu-is-open')) {
				body.classList.remove('menu-is-open');
				enablePageScroll(body);
			}
		}

		toggle() {
			this.helpers();
			body.classList.toggle('menu-is-open');
			if (body.classList.contains('menu-is-open')) {
				disablePageScroll(body);
			} else {
				enablePageScroll(body);
			}
		}
		close() {
			enablePageScroll(body);
			body.classList.remove('menu-is-open');
		}

		helpers = () => {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		};
	};
};
